import React from 'react'
import * as E from './bannerBrandImageSectionElements'
import { Link } from 'react-router-dom'
import ContactUsDialog from 'application/components/dialog/contactUsDialog'
import globals from 'application/constants/globals'

type basicButtonProps = {
  disabled: boolean
  buttonName: string
  buttonFunction?: () => {}
  linkUrl?: string
}

interface BannerBrandImageSectionProps {
  imageText?: string
  firstButton?: basicButtonProps
  secondButton?: basicButtonProps
  sectionTitle?: string
  sectionContent?: string
  id?: string
  showConsultantButton?: boolean
  children?: any // do we need this?
  bannerImageName?: string
}

const BannerBrandImageSection = (props: BannerBrandImageSectionProps) => {

  const FirstButtonContents = () => ( 
    <E.StyledPrimaryButton invertColor={globals.isBrandMX} disabled={props.firstButton?.disabled}>
      {props.firstButton?.buttonName}
    </E.StyledPrimaryButton>
  )

  const SecondButtonContents = () =>(
    <E.StyledPrimaryButton
    invertColor={globals.isBrandRS}
    disabled={props.secondButton?.disabled}
    extendInMob
    >
      {props.secondButton?.buttonName}
    </E.StyledPrimaryButton>
  )
  
  const hasValidUrlProtocol = (url:string) => 
    ['http://', 'https://'].some(protocol => url.startsWith(protocol))

  return (
    <E.BannerContentBlock id={props.id}>
      <E.ImageDiv maxxiaImageName={props.bannerImageName}>
        <E.ImageHeading>
          {globals.isBrandRS && <E.WhiteHeading>REMSERV LEASE</E.WhiteHeading>}
          {props.imageText
            ? props.imageText
            : globals.isBrandMX
            ? 'The wheels are in motion!'
            : `Ready to get in the driver’s seat?`}
        </E.ImageHeading>
      </E.ImageDiv>
      <E.BannerContentParentDiv fluid>
        <E.BannerConstChildDiv id={props.id} tabIndex={-1}>
          <E.BannerTextSection>
            <E.BannerTitle>{props.sectionTitle}</E.BannerTitle>
            <E.BannerContent>{props.sectionContent}</E.BannerContent>
          </E.BannerTextSection>
          {(props.firstButton?.buttonName ||
            props.secondButton?.buttonName ||
            props.showConsultantButton) && (
            <E.BannerButtonSection>
              {props.firstButton?.linkUrl ? (
                hasValidUrlProtocol(props.firstButton?.linkUrl) ? 
                <a href={props.firstButton?.linkUrl}
                  target="_blank" 
                  rel="noopener noreferrer"
                  tabIndex={-1}
                  className="mt-3 mr-3 w-100">
                  <FirstButtonContents />

                </a> 
                :
                <Link
                  to={{ pathname: props.firstButton?.linkUrl }}
                  tabIndex={-1}
                  className="mt-3 mr-3 w-100"
                >
                  <FirstButtonContents />
                </Link>
              ) : (
                props.firstButton?.buttonName && (
                  <div className="mt-3 mr-3 w-100">
                    <FirstButtonContents />
                  </div>
                )
              )}
              {props.showConsultantButton ? (
                <ContactUsDialog
                  className="text-brand font-weight-bold border border-white mt-3 mr-3"
                  theme="button"
                  size="lg"
                  launchText="Contact my consultant"
                  id="estimateacceptedstate.contact"
                />
              ) : props.secondButton?.linkUrl ? (
                hasValidUrlProtocol(props.secondButton?.linkUrl) ? 
                  <a href={props.secondButton?.linkUrl}
                    target="_blank" 
                    rel="noopener noreferrer"
                    tabIndex={-1}
                    className="mt-3 mr-3 w-100">
                      <SecondButtonContents />
                  </a>
                :
                  <Link
                    to={{ pathname: props.secondButton?.linkUrl }}
                    tabIndex={-1}
                    className="mt-3 mr-3 w-100"
                  >
                    <SecondButtonContents />
                  </Link>
              ) : (
                props.secondButton?.buttonName && (
                  <div className="mt-3 mr-3">
                    <SecondButtonContents />
                  </div>
                )
              )}
            </E.BannerButtonSection>
          )}
        </E.BannerConstChildDiv>
      </E.BannerContentParentDiv>
    </E.BannerContentBlock>
  )
}

export default BannerBrandImageSection
